import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var InlineFieldsContainer = _styled("div", {
  target: "ehtiu3n0",
  label: "InlineFieldsContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "ir3bqg",
  styles: "display:flex;justify-content:space-between;> div{width:calc(50% - 8px);}"
} : {
  name: "ir3bqg",
  styles: "display:flex;justify-content:space-between;> div{width:calc(50% - 8px);}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0NvbW1vbi9JbmxpbmVGaWVsZHNDb250YWluZXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRXdDIiwiZmlsZSI6Ii4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0NvbW1vbi9JbmxpbmVGaWVsZHNDb250YWluZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmNvbnN0IElubGluZUZpZWxkc0NvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcblxuICA+IGRpdiB7XG4gICAgd2lkdGg6IGNhbGMoNTAlIC0gOHB4KTtcbiAgfVxuYDtcblxuZXhwb3J0IHsgSW5saW5lRmllbGRzQ29udGFpbmVyIH07XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export { InlineFieldsContainer };